/**
 * @generated SignedSource<<02d451ec9ebe540113ffd0d7c8df6e57>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "assignmentTypeId"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "assignmentTypeId"
                }
            ],
            "concreteType": "AssignmentType",
            "kind": "LinkedField",
            "name": "assignmentType",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AssignmentTypeGeneralInfoUpdateModalQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AssignmentTypeGeneralInfoUpdateModalQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "008cd2cf7e15ffb50fabfe7b7b34752e",
            "id": null,
            "metadata": {},
            "name": "AssignmentTypeGeneralInfoUpdateModalQuery",
            "operationKind": "query",
            "text": "query AssignmentTypeGeneralInfoUpdateModalQuery(\n  $assignmentTypeId: ID!\n) {\n  assignmentType(id: $assignmentTypeId) {\n    id\n    title\n  }\n}\n"
        }
    };
})();
node.hash = "59c302799a5da5d96daa1b380f004f47";
export default node;
